export default __webpack_public_path__ + "static/media/alquiler.0e5ffea9.jpg";